export const openInNewTab = (url) => {
  window?.open?.(url, '_blank');
};

export const cmdClickOpenInNewTab = (url, e) => {
  if (url && (e.metaKey || e.ctrlKey)) {
    openInNewTab(url);
    return true;
  }
  return false;
};
